import Vue from 'vue'
import App from './App.vue'

import './assets/styles/main.css'

import './assets/styles/animate.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

Vue.config.productionTip = false

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "UA-67252475-4" }
});

console.log('WAMP:', process.env.VUE_APP_WAMP_URL)

import VueWamp from 'vue-wamp'
Vue.use(VueWamp, {
  url: process.env.VUE_APP_WAMP_URL,
  realm: 'waitry.realm1',
  namespace: 'wamp',
  auto_reestablish: true,
  auto_close_timeout: -1,
});

new Vue({
  render: h => h(App),
}).$mount('#app')
